import React from 'react';
import gql from 'graphql-tag';
import { Link } from 'react-router';
import { BUILDER } from '../../src/shared/abilities';
import AdminNavbarItem from '../../src/admin/layout/components/AdminNavbarItem';
import { FLIPPER_VOYAGER_HEADER_FOOTER_SETS } from '../../constants/flippers';
import useQuery from '../../modules/react/hooks/useQuery';
import useFlipper from '../../modules/react/hooks/useFlipper';

const GET_DEFAULT_PAGE_LAYOUT = gql`
  query GetDefaultPageLayout {
    currentSite {
      id
      primaryPageLayout {
        id
        latestVersion {
          id
        }
        pageLayoutType {
          id
        }
      }
    }
  }
`;

const propTypes = {};
const defaultProps = {};

const AdminLayoutNavbarButton = () => {
  const localLayoutsEnabled = useFlipper(FLIPPER_VOYAGER_HEADER_FOOTER_SETS);
  const icon = localLayoutsEnabled ? 'local' : 'global';
  const text = localLayoutsEnabled ? 'Layouts' : 'Global Layout';
  let to;
  let disabled;

  const { data, loading } = useQuery(GET_DEFAULT_PAGE_LAYOUT, { ssr: false });

  if (loading) {
    disabled = true;
  } else if (!data || !data.currentSite || !data.currentSite.primaryPageLayout) {
    // NOTE: a primary layout doesn’t exist when the modal pops up because the site hasn’t
    // been built yet => layout button doesn't have a primary layout to link to
    to = '/admin';
  } else {
    const { currentSite: { primaryPageLayout: { latestVersion, pageLayoutType } } } = data;
    to = `/admin/locales/en-us/types/${pageLayoutType.id}/page-layout/versions/${latestVersion.id}/edit`;
  }

  return (
    <AdminNavbarItem
      authorization={{
        action: 'manage',
        subject: BUILDER,
        text: `edit ${text.toLowerCase()}`,
      }}
      icon={icon}
      text={text}
      componentClass={Link}
      to={to}
      disabled={disabled}
    />
  );
};

AdminLayoutNavbarButton.propTypes = propTypes;
AdminLayoutNavbarButton.defaultProps = defaultProps;

AdminLayoutNavbarButton.fragments = {};

export default AdminLayoutNavbarButton;
